import { Navigate, useLocation, useParams } from "react-router";

/** Redirects to `to` (with `:param`s filled from the URL), keeping the query string and hash. */
export function Redirect({ to, search }: { to: string; search?: string }) {
  const params = useParams();
  const location = useLocation();
  const path = to.replace(/:(\w+)/g, (_, name: string) => encodeURIComponent(params[name] ?? ""));
  return <Navigate to={`${path}${search ?? location.search}${location.hash}`} replace />;
}
